import { render, staticRenderFns } from "./BottomFooterContent.vue?vue&type=template&id=338ee1cf&scoped=true"
import script from "./BottomFooterContent.vue?vue&type=script&lang=js"
export * from "./BottomFooterContent.vue?vue&type=script&lang=js"
import style0 from "./BottomFooterContent.vue?vue&type=style&index=0&id=338ee1cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ee1cf",
  null
  
)

export default component.exports